"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * A function that lets you know if the environment is nodejs or not
 *
 * @returns true if the environment is nodejs, false otherwise.
 */
function isNodeJS() {
  if (typeof process !== 'undefined') {
    return process && process.release && process.release.name && process.release.name.search(/node|io.js/) !== -1;
  }

  return false;
}

var _default = isNodeJS;
exports["default"] = _default;